/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import * as Player from './Player';

export type AppSettings = {
	initialLifePoints: number,
	setInitialLifePoints(value: number): void,
	matches: number,
	setMatches(value: number): void, 
	leftPlayer: Player.Model,
	setLeftPlayer(value: Player.Model): void,
	rightPlayer: Player.Model,
	setRightPlayer(value: Player.Model): void,
	volume: number,
	setVolume(value: number): void
};

export const saveToLocalStorage = (settings: AppSettings) => {
	window.localStorage.setItem('settings', JSON.stringify(settings));
}

export const loadFromLocalStorage = (): AppSettings => {
	if(window.localStorage.getItem('settings') !== null) {
		let rawSettings: string | null = window.localStorage.getItem('settings');
		return JSON.parse(rawSettings != null ? rawSettings : "") as AppSettings;
	} else {
		return createDefaultSettings();
	}
}

export const createDefaultSettings = (): AppSettings => {
	return {
		"initialLifePoints": 8000,
		"setInitialLifePoints": () => {},
		"matches": 3,
		"setMatches": () => {},
		"leftPlayer": Player.create("Left Player", Player.Position.LEFT),
		"setLeftPlayer": () => {},
		"rightPlayer": Player.create("Right Player", Player.Position.RIGHT),
		"setRightPlayer": () => {},
		"volume": 100,
		"setVolume": () => {}
	}
}
